import React, { useState, useEffect, useRef  } from 'react';
import { useNavigate } from 'react-router-dom';
import { Modal, ModalBody, Button } from 'reactstrap';
import 'bootstrap/dist/css/bootstrap.min.css';

import insertlogo from '../../Assets/App_icon/insert.png';
import backlogo from '../../Assets/App_icon/back.png';

const CategoryMaster = () => {
  
  const store = localStorage.getItem('store');
  const host_url = localStorage.getItem('host_url');

  const fileInputRef = useRef(null);
  const navigate = useNavigate();
  const [modalVisible, setModalVisible] = useState(false); 
  const [addmodalVisible, setAddModalVisible] = useState(false); 
  
  
  const [catlist, setCatlist] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState('');
  const [uploadImage, setUploadImage] = useState('');
  const [imagePreview, setImagePreview] = useState(null);

  const handleBack = () => {
    navigate('../dashboard');
  };

    useEffect(() => {
      document.title = "Category Master";
    }, []); // for Title Set

    // Escape key press handling
    useEffect(() => {
      setImagePreview('');
      setUploadImage('');
      const handleKeyPress = (event) => {
        if (event.key === "Escape") {
          // Close modal or navigate back if no modal is open
          if (modalVisible || addmodalVisible) {
            setModalVisible(false);
            setAddModalVisible(false);
          } else {
            handleBack();
          }
        }
        
        if (event.key === "Insert" && !addmodalVisible) {
          setAddModalVisible(true);
        }
      };

      document.addEventListener("keydown", handleKeyPress);
      return () => {
        document.removeEventListener("keydown", handleKeyPress);
      };
    }, [modalVisible, addmodalVisible]);

    useEffect(() => { 
      const fetchCatagoryList = async () => { 
          const formData = new FormData();
          formData.append("type", "list");
          formData.append("store", store);
          formData.append("catlist", '');

          try {
            const response = await fetch(`${host_url}/category_mlist`, {
              method: 'POST',
              headers: {
                'userid': localStorage.getItem('userid'),
              },
              body: formData,
            });
            
            if (response.status === 401) {
              localStorage.clear();
              alert('Your account has been disabled.');
              window.location.href = "/";
              return;
            }
      
            const data = await response.json();
            setCatlist(data);
          } catch (error) {
            console.error('Error fetching categories:', error);
          }
      }; 
     fetchCatagoryList(); 
    }, [host_url, store, modalVisible, addmodalVisible]); 

    

    const [catNameFilter, setCatNameFilter] = useState('');
    const [catEnameFilter, setCatEnameFilter] = useState('');
    const [catStatusFilter, setCatStatusFilter] = useState('');

    const filteredCatlist = catlist.filter(catlist =>
      catlist.pcat_Ename.toLowerCase().includes(catNameFilter.toLowerCase()) &&
      catlist.pcat_name.toLowerCase().includes(catEnameFilter.toLowerCase()) &&
      catlist.pcat_status.toLowerCase().includes(catStatusFilter.toLowerCase())
    );

    const totalCount = filteredCatlist.length;
    const totalProduct = filteredCatlist.reduce((sum, catlist) => sum + Number(catlist.pcat_count), 0);
    const totalShowProduct = filteredCatlist.reduce((sum, catlist) => sum + Number(catlist.pcat_show_count), 0);


    const handleCategoryDetail = (user) => {
      setModalVisible(true);
      setSelectedCategory(user);
    };

    // Functions for handling the different actions
    const handleAddCategory = async () => {
      setAddModalVisible(false);
      const formData = new FormData();
      formData.append('image', uploadImage);
      formData.append("type", "insert");
      formData.append("store", store);
      formData.append("catlist", JSON.stringify(selectedCategory));
      
      try {
        const response = await fetch(`${host_url}/category_mlist`, {
          method: 'POST',
          body: formData,
        });
        
        const data = await response.json();
        setCatlist(data);
      } catch (error) {
        console.error('Error fetching categories:', error);
      }   
    };

    const handleUpdateCategory = async () => {
      setModalVisible(false);
      const formData = new FormData();
        if (uploadImage) {
          formData.append('image', uploadImage);
          formData.append("type", "update");
          formData.append("store", store);
          formData.append("catlist", JSON.stringify(selectedCategory));
        } else {
          formData.append("type", "update");
          formData.append("store", store);
          formData.append("catlist", JSON.stringify(selectedCategory));
        } 

      try {
        const response = await fetch(`${host_url}/category_mlist`, {
          method: 'POST',
          body: formData,
        });
        
        const data = await response.json();
        setCatlist(data);
      } catch (error) {
        console.error('Error fetching categories:', error);
      }    
    };

    const handleDeleteCategory = async () => {
      setModalVisible(false);
      const userConfirmed = window.confirm('Are you sure you want to delete this Category?');
      if (userConfirmed) {
        const formData = new FormData();
        formData.append("type", "delete");
        formData.append("store", store);
        formData.append("catlist", JSON.stringify(selectedCategory));
        
        try {
          const response = await fetch(`${host_url}/category_mlist`, {
            method: 'POST',
            body: formData,
          });
          
          const data = await response.json();
          setCatlist(data);
        } catch (error) {
          console.error('Error fetching categories:', error);
        }   
      } 
    };

    const handleAddModal = async (e) => {
      setSelectedCategory('');
      setAddModalVisible(true);
    };

    const handleImage = async (e) => {
      if (fileInputRef.current) {
        fileInputRef.current.click();
      }
    };

    const handleFileChange = async (e) => {
      const file = e.target.files[0];
      
      if(file) {
        setUploadImage(e.target.files[0]);
        const previewUrl = URL.createObjectURL(file);
        setImagePreview(previewUrl);
      }
    };

  return (
    <div className="container">
          <div style={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}>
              <div onClick={handleBack}>
                <img src={backlogo} alt="Back" className='system-icon'/>
              </div>
              <b style={{ margin: '10px', fontSize: '20px' }}>Category Master</b>
              <div onClick={handleAddModal}>
                <img src={insertlogo} alt="Back" className='system-icon'/>
              </div>
          </div>
         
        
          <table className="table-bordered table-sm custom-hover">
            <thead>
              <tr >
                <th></th>
                <th colSpan='2'>Name</th>
                <th colSpan='2'>G_name</th>
                <th>Status</th>
                <th>Product</th>
              </tr>
              <tr>
                 <th></th>
                <th colSpan='2'>
                  <input
                    type="text"
                    className="search-input"
                    value={catNameFilter}
                    onChange={(e) => setCatNameFilter(e.target.value)}
                  />
                </th>
                <th colSpan='2'>
                  <input
                    type="text"
                    className="search-input"
                    value={catEnameFilter}
                    onChange={(e) => setCatEnameFilter(e.target.value)}
                  />
                </th>
                <th>
                  <select
                    className="search-input"
                    value={catStatusFilter}
                    onChange={(e) => setCatStatusFilter(e.target.value)}
                  >
                    <option value="">All Status</option>
                    <option value="Y">Active</option>
                    <option value="N">Inactive</option>
                  </select>
                </th>
                <th></th>
              </tr>
            </thead>
            <tbody className="scrollable-body">
              {filteredCatlist.map((row) => {
                  return (
                    <tr key={row.pcat_id} style={{ lineHeight: '10px' }} onClick={() => handleCategoryDetail(row)}>
                      <td style={{ padding: 0 }}><img src={row.pcat_image_url} alt="Category" width="50" height="50"/></td>
                      <td className="cell-left" colSpan='2'><span style={{ paddingLeft: '10px' }}>{row.pcat_Ename}</span></td>
                      <td className="cell-left" colSpan='2'><span style={{ paddingLeft: '10px' }}>{row.pcat_name}</span></td>
                      <td>
                        <span style={{display: 'flex', paddingLeft: '10px'}}>
                          <span style={{ width: '10px', height: '10px', borderRadius: '50%', backgroundColor: row.pcat_status === 'N' ? '#ff0000' : '#00962d', marginRight: '5px'}}></span>
                          <span>{row.pcat_status === 'N' ? 'Inactive' : 'Active'}</span>
                        </span>
                      </td>
                      <td className="cell-right"><span style={{ paddingRight: '10px' }}>{row.pcat_show_count} / {row.pcat_count} </span></td>
                    </tr>
                  );
              })}
            </tbody>
            <tfoot>
              <tr >
                <th className="cell-left"><span style={{ paddingLeft: '15px' }}>{totalCount}</span></th>
                <th className="cell-left" colSpan='2'><span style={{ paddingLeft: '10px' }}>Total</span></th>
                <th className="cell-right"><span style={{ paddingRight: '15px' }}>{totalShowProduct} / {totalProduct} </span></th>
              </tr>
            </tfoot>
          </table>
          

          {/* Modal for Category Detail */}
            <Modal isOpen={modalVisible} toggle={() => setModalVisible(!modalVisible)} className="detailmodal-lg" backdrop="static" keyboard={false}>
              <ModalBody style={{ backgroundColor: '#e8fadb'}}>
                <h5 >Order Detail</h5>  
                <div style={{ display: 'flex', justifyContent: 'center', width: '100%'}}>
                  <div style={{ display: 'flex', justifyContent: 'center', width: '38%', marginRight: '2%', border: '2px solid #dcdcdc'}}>
                     <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center',  }}>
                       <img 
                        src={imagePreview ? imagePreview : selectedCategory.pcat_image_url} 
                        alt="Category" 
                        style={{ width: '200px', height: '200px', objectFit: 'contain' }} 
                      />
                    </div>
                  </div>
                  <div style={{ display: 'flex', justifyContent: 'center', width: '60%', border: '2px solid #dcdcdc'}}>
                    <table style={{ backgroundColor: '#e8fadb', border: '0px', width: '100%', borderCollapse: 'collapse' }}>
                      <tbody>
                        <tr>
                          <td className="cell-left">E_Name</td>
                          <td><input type="text" value={selectedCategory.pcat_Ename} onChange={(e) => setSelectedCategory({ ...selectedCategory, pcat_Ename: e.target.value })} /></td>
                        </tr>
                        <tr>
                          <td className="cell-left">G_Name</td>
                          <td><input type="text" value={selectedCategory.pcat_name} onChange={(e) => setSelectedCategory({ ...selectedCategory, pcat_name: e.target.value })} /></td>
                        </tr>
                        <tr>
                          <td className="cell-left">Status</td>
                          <td><select
                                value={selectedCategory.pcat_status}
                                onChange={(e) => setSelectedCategory({ ...selectedCategory, pcat_status: e.target.value })}
                              >
                                <option value="Y">Active</option>
                                <option value="N">Inactive</option>
                              </select>
                          </td>                      
                        </tr>
                        <tr>
                          <td colSpan='2'>
                            <div style={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}>      
                              {selectedCategory.pcat_count < 1 && (
                                <Button color="danger" style={{ flex: 1, marginLeft: '10px', marginRight: '10px' }} onClick={handleDeleteCategory} >
                                  Delete
                                </Button>
                              )}
                                <Button color="info" style={{ flex: 1, marginLeft: '10px', marginRight: '10px' }} onClick={handleImage}>
                                  Image 
                                </Button>
                                <input type="file" style={{ display: 'none' }} accept="image/*" ref={fileInputRef} onChange={handleFileChange} /> 
                                <Button color="success" style={{ flex: 1, marginLeft: '10px', marginRight: '10px' }} onClick={handleUpdateCategory}>
                                  Udate
                                </Button>
                                <Button color="primary" style={{ flex: 1, marginLeft: '10px', marginRight: '10px' }} onClick={() => setModalVisible(false)}>
                                  Close
                                </Button>
                            </div>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </ModalBody>
            </Modal>

          {/* Modal for Add New Category */}
            <Modal isOpen={addmodalVisible} toggle={() => setModalVisible(!addmodalVisible)} className="detailmodal-lg" backdrop="static" keyboard={false}>
              <ModalBody style={{ backgroundColor: '#e8fadb'}}>
                <h5 >Add New Category</h5>  
                <div style={{ display: 'flex', justifyContent: 'center', width: '100%'}}>
                  <div style={{ display: 'flex', justifyContent: 'center', width: '38%', marginRight: '2%', border: '2px solid #dcdcdc'}}>
                     <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center',  }}>
                       <img 
                        src={imagePreview} 
                        alt="Category" 
                        style={{ width: '200px', height: '200px', objectFit: 'contain' }} 
                      />
                    </div>
                  </div>
                  <div style={{ display: 'flex', justifyContent: 'center', width: '60%', border: '2px solid #dcdcdc'}}>
                    <table style={{ backgroundColor: '#e8fadb', border: '0px', width: '100%', borderCollapse: 'collapse' }}>
                      <tbody>
                        <tr>
                          <td className="cell-left">E_Name</td>
                          <td><input type="text" value={selectedCategory.pcat_Ename} onChange={(e) => setSelectedCategory({...selectedCategory, pcat_Ename: e.target.value })} /></td>
                        </tr>
                        <tr>
                          <td className="cell-left">G_Name</td>
                          <td><input type="text" value={selectedCategory.pcat_name} onChange={(e) => setSelectedCategory({ ...selectedCategory, pcat_name: e.target.value })} /></td>
                        </tr>
                        <tr>
                          <td className="cell-left">Status</td>
                          <td><select
                                value={selectedCategory.pcat_status}
                                onChange={(e) => setSelectedCategory({ ...selectedCategory, pcat_status: e.target.value })}
                              >
                                <option value="">Select Status</option>
                                <option value="Y">Active</option>
                                <option value="N">Inactive</option>
                              </select>
                          </td>                      
                        </tr>
                        <tr>
                          <td colSpan='2'>
                            <div style={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}>      
                                <Button color="info" style={{ flex: 1, marginLeft: '10px', marginRight: '10px' }} onClick={handleImage}>
                                  Image 
                                </Button>
                                <input type="file" style={{ display: 'none' }} accept="image/*" ref={fileInputRef} onChange={handleFileChange} /> 
                                
                                <Button 
                                  color="success" 
                                  style={{ flex: 1, marginLeft: '10px', marginRight: '10px' }} 
                                  onClick={handleAddCategory}
                                  disabled={!imagePreview || !selectedCategory.pcat_Ename || !selectedCategory.pcat_name || !selectedCategory.pcat_status}
                                >
                                  Submit
                                </Button>
                                <Button color="primary" style={{ flex: 1, marginLeft: '10px', marginRight: '10px' }} onClick={() => setAddModalVisible(false)}>
                                  Close
                                </Button>
                            </div>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </ModalBody>
            </Modal>


    </div>
  );
};

export default CategoryMaster;
